// Golf 5 (Duits): toestemming van een ouder voor een kind onder 16 (eigen login, foto) en de
// pagina met de privacyverklaring. Zelfde vorm als golf5App.nl.ts; de toestemmingsteksten tellen
// mee in CHILD_CONSENT_TEXT_HASHES.
export const appChildConsentDe = {
    version: '2026-09-26.1',
    title: 'Einwilligung für {name}',
    intro: '{name} ist jünger als 16. Für einen eigenen Login oder ein Foto fragen wir zuerst einen Elternteil um Einwilligung.',
    notNeeded: '{name} ist 16 oder älter und entscheidet selbst über einen eigenen Login und ein Foto.',
    login: {
        title: 'Eigener Login',
        text: 'Mit einem eigenen Login kann sich {name} selbst in der App anmelden, auf einem Handy oder Computer. {name} sieht dann den eigenen Kalender, die Aufgaben, Punkte und Nachrichten der Familie, aber nie Einwilligungen, E-Mail-Adressen oder Gesundheitsdaten. AMUMIN B.V. speichert, wer die Einwilligung gab, wann und welchen Text du gelesen hast. Du kannst sie jederzeit widerrufen: Der Login funktioniert dann sofort nicht mehr.',
        check: 'Ich bin Elternteil oder Vormund von {name} und willige in einen eigenen Login ein.',
    },
    photo: {
        title: 'Foto als Avatar',
        text: 'Mit Einwilligung kannst du statt eines Symbols ein Foto von {name} verwenden. Das Foto erscheint dann in der App und auf der Tafel an der Wand: Alle im Raum mit dem Tablet sehen es. Wir entfernen den Ort und andere Daten aus dem Foto und teilen es mit niemandem. AMUMIN B.V. speichert, wer die Einwilligung gab, wann und welchen Text du gelesen hast. Du kannst sie jederzeit widerrufen: Das Foto ist dann sofort weg.',
        check: 'Ich bin Elternteil oder Vormund von {name} und willige in ein Foto ein.',
    },
    ask: 'Einwilligung geben',
    give: 'Einwilligen',
    cancel: 'Jetzt nicht',
    withdraw: 'Widerrufen',
    withdrawConfirm: 'Ja, widerrufen',
    withdrawLogin: 'Einwilligung für den eigenen Login widerrufen? Der Login von {name} funktioniert dann sofort nicht mehr.',
    withdrawPhoto: 'Einwilligung für das Foto widerrufen? Das Foto von {name} ist dann sofort weg.',
    none: 'Noch keine Einwilligung',
    givenBy: 'Einwilligung von {name} am {date}',
    givenByYou: 'Deine Einwilligung am {date}',
    givenOn: 'Einwilligung am {date}',
    hasLogin: '{name} hat jetzt einen eigenen Login.',
    hasPhoto: '{name} hat jetzt ein Foto.',
    given: 'Einwilligung gegeben',
    withdrawn: 'Einwilligung widerrufen',
    withdrawnLogin: 'Der Login von {name} funktioniert nicht mehr.',
    withdrawnPhoto: 'Das Foto von {name} ist entfernt.',
    checkRequired: 'Setze zuerst das Häkchen.',
    privacyLink: 'Mehr in der Datenschutzerklärung',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: '{name} hat schon einen Login ohne Einwilligung: Gib die Einwilligung oder schalte den Login aus.',
    disableLogin: 'Login ausschalten',
    disableLoginAsk: 'Den Login von {name} ausschalten? Er funktioniert dann sofort nicht mehr.',
    disableLoginConfirm: 'Ja, ausschalten',
    loginDisabled: 'Der Login von {name} ist aus.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'Diese Kinder haben schon einen Login ohne Einwilligung: Gib die Einwilligung oder schalte den Login aus.',
    gateLogin: 'Diese Person hat einen eigenen Login. Ein Kind unter 16 braucht zuerst die Einwilligung eines Elternteils: Entferne zuerst den Login, ändere dann das Alter und gib danach die Einwilligung.',
    gatePhoto: 'Ein Foto eines Kindes unter 16 geht nur mit Einwilligung eines Elternteils. Gib zuerst die Einwilligung oder entferne das Foto.',
};
export const appPrivacyStatementDe = {
    title: 'Datenschutzerklärung',
    back: 'Zurück zur App',
    concept: 'Entwurf, wird juristisch geprüft',
    version: 'Version {version} · {date}',
    contents: 'Inhalt',
    onlyDutch: 'Diese Datenschutzerklärung gibt es noch nicht auf Deutsch. Unten steht der niederländische Text; du kannst auch Englisch wählen.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    placeholder: 'wird noch ergänzt',
};
//# sourceMappingURL=golf5App.de.js.map